export default {
    API_URL: "https://clubapi.clubdaddy.net/api",
    API_MEDIA_URL: "https://apimedia.draftplaza.com/api",
    API_CASINO_URL: "https://clubapi.clubdaddy.net",
    BO_API_URL: "https://tslotsbo.pokerplaza.com/backoffice/api/v2",
    POKER_CLIENT_URL: "https://poker.clubdaddy.net",
    POKER_CLIENT_URL_DESKTOP: "https://poker.clubdaddy.net",
    API_TOURNAMENT_URL: "https://stagingcasinotoursapi.pokerplaza.com",
    SILVER_HOME_URL: 'https://apps2.pokerplaza.com/coinbar',
    UNIVERSAL_HOME_URL: 'https://apps2.pokerplaza.com/coinbar/close.php',
    MESSAGES_API: "https://newsservice.clubdaddy.net/api",
    SHOP_URL: "http://clubgames.pokerplaza.com/shop",
    HOME_URL: "https://gamedaddy.com",
    TERMS_AND_CONDITIONS_URL_: "https://clubdaddy.net/terms",
    PRIVACY_POLICY_URL_: "https://clubdaddy.net/privacy-policy",
    mainMenuItems: ['home', 'profile'],
    clubMenuItems: ['messages', 'members', 'counter', 'data', 'settings'],
    supportedTabs: ['betting', 'casino', 'liveCasino', 'poker'],
    globalSkinId: 169,
    userExtraRoles: ['agent'],
    createClubWithCode: true,
    googleAnalytics: 'G-MJ13EZBN9C',
    closeDialogOnlyFromTop: true,
    fetchDataIntervals: {
        auth: 20000,
        messages: 27900,
        clubMembers: 27000,
        tournamentCasinoUpdateInterval: 90000,
    },
    createTable: {
        enabled: true,
        insurance: true,
        options: ['byh', 'ipRestriction']
    },
    clubCurrency: 'fruit'
}
